import { fetchOrder } from 'entities/Order';

import type { AppDispatch } from 'app/providers/StoreProvider';
import type { Order } from 'entities/Order/model/types/OrderSchema';

export const applyAddedListOrder = (dispatch: AppDispatch, order: Order) => {
    dispatch(
        fetchOrder.fulfilled(
            { data: order, isCatalog: true },
            `custom-list-add-${order.id}`,
            { id: order.id, isCatalog: true },
        ),
    );
};
